<template>
    <div>
        <!-- display mobile view filter options -->
        <div class="d-md-none">
            <app-search-filter-mobile 
                :resultsCountMsg="resultsCountMsg" 
                :theSortOptions="theSortOptions" 
                :theCategories="theCategories" 
                :theConditions="theConditions" 
                :clearFilterCheck="clearFilterCheck" 
                @emitSortByFxn="sortByFxn" 
                @emitSetPriceFxn="setPriceFxn" 
                @emitConditionFxn="conditionFxn" 
                @emitCategoryFxn="categoryFxn" 
                @emitClearFilterFxn="clearFilterFxn" 
            ></app-search-filter-mobile>
        </div>
        
        <!-- display desktop view filter options -->
        <div class="row d-none d-md-block">
            <div class="col-12">
                <p class="my-2">
                    <i class="fas fa-poll-h fa-sm"></i>  
                    <span class="font-weight-bold"> Found</span> 
                    {{resultsCountMsg}} 
                </p>
                <hr class="d-none d-md-block">
            </div>

            <div v-if="clearFilterCheck" class="col-12 my-3">
                <div class="input-group input-group-sm">
                    <button @click.prevent="clearFilterFxn" class="form-control btn btn-light bg-white btn-sm text-danger">
                        Clear filters <i class="fas fa-times-circle fa-sm"></i>
                    </button>
                </div>
            </div>
            
            <div class="col-12">
                <label for="sort" class="font-weight-bold">Sorting</label>
                <div class="input-group input-group-sm">
                    <select v-model="sortBy" @change="sortByFxn()" ref="sort" id="sort" class="custom-select no-lines bg-white" style="border-color: #DFDFDF;">
                        <option selected disabled value="">sort by</option>
                        <option v-for="(sortOption, index) in theSortOptions" :key="index" :value="sortOption.value">{{sortOption.text}}</option>
                    </select>
                </div>
            </div>

            <div class="col-12 mt-4">
                <label for="price" class="font-weight-bold">Set Price</label>
                <div class="input-group input-group-sm">
                    <input v-model="priceMin" @keyup.enter="setPriceFxn()" type="text" placeholder="min" class="form-control no-lines bg-white">
                    <input v-model="priceMax" @keyup.enter="setPriceFxn()" type="text" placeholder="max" class="form-control no-lines bg-white">
                </div>
            </div>
            
            <div class="col-12 mt-4">
                <label for="condition" class="font-weight-bold">Condition</label>
                <div class="input-group input-group-sm">
                    <select v-model="selectedCondition" @change="conditionFxn()" ref="condition" class="custom-select no-lines bg-white" style="border-color: #DFDFDF;">
                        <option selected disabled value="">select condition</option>
                        <option v-for="(condition, index) in theConditions" :key="index" :value="condition.condition">{{condition.condition}}</option>
                    </select>
                </div>
            </div>

            <div class="col-12 my-4">
                <label for="category" class="font-weight-bold">Category</label>
                <div class="input-group input-group-sm">
                    <select v-model="selectedCategory" @change="categoryFxn()" ref="category" class="custom-select no-lines bg-white" style="border-color: #DFDFDF;">
                        <option selected disabled value="">select category</option>
                        <option v-for="(category, index) in theCategories" :key="index" :value="category.category">{{category.category}}</option>
                    </select>
                </div>
            </div>
            
            <!-- display all categories on the side -->
            <template class="d-none d-md-block">
                <div v-if="theCategories" class="col-12 my-4">
                    <hr>
                    <label for="category" class="font-weight-bold"><i class="fas fa-layer-group"></i> More Categories</label>
                    <div class="mt-2">
                        <p v-for="(categoryObj, index) in theCategories" :key="index" >
                            <router-link  :to="{ name: 'category-items', params: { category: categoryObj.category } }" exact>
                                {{categoryObj.category | capitalize}}
                            </router-link>
                        </p>
                    </div>
                </div>
            </template>

        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import SearchFilterMobile from './SearchFilterMobile.vue'

export default {
    name: "SearchFilter",
    data() {
        return {
            sortBy: '',
            priceMin: null,
            priceMax: null,
            selectedCategory: '',
            selectedCondition: '',
        }
    },
    methods: {
        ...mapActions([
            'filterByNewestAction', 'filterByRelevanceAction', 'filterByExpensiveAction', 'filterByAffordableAction', 
            'filterByPriceAction', 'filterByConditionAction', 'filterByCategoryAction', 'clearFilterAction'
        ]),
        sortByFxn(emittedMobileSortVal) {
            // receive the value if fxn was called from the mobile html inputs
            if(emittedMobileSortVal) { this.sortBy = emittedMobileSortVal }

            // process the input for both desktop and mobile here
            if(this.sortBy === 'newest') return this.filterByNewestAction().then(() => {}).catch((e) => {})
            if(this.sortBy === 'relevance') return this.filterByRelevanceAction().then(() => {}).catch((e) => {})
            if(this.sortBy === 'expensive') return this.filterByExpensiveAction().then(() => {}).catch((e) => {})
            if(this.sortBy === 'affordable') return this.filterByAffordableAction().then(() => {}).catch((e) => {})
        },
        setPriceFxn(emittedMobilePriceVal) {
            let priceObj = {
                min: this.priceMin,
                max: this.priceMax
            }
            // receive the value if fxn was called from the mobile html inputs
            if(emittedMobilePriceVal) { priceObj = emittedMobilePriceVal }
            return this.filterByPriceAction(priceObj).then(() => {}).catch((e) => {})
        },
        conditionFxn(emittedMobileConditionVal) {
            let conditionObj = {
                condition: this.selectedCondition
            }
            // receive the value if fxn was called from the mobile html inputs
            if(emittedMobileConditionVal) { conditionObj = emittedMobileConditionVal }
            return this.filterByConditionAction(conditionObj).then(() => {}).catch((e) => {})
        },
        categoryFxn(emittedMobileCategoryVal) {
            let categoryObj = {
                category: this.selectedCategory
            }
            // receive the value if fxn was called from the mobile html inputs
            if(emittedMobileCategoryVal) { categoryObj = emittedMobileCategoryVal }
            return this.filterByCategoryAction(categoryObj).then(() => {}).catch((e) => {})
        },
        clearFilterFxn() {
            this.clearFilterAction()
            .then(() => {
                this.resetAllInput()
            })
            .catch((e) => {})
        },
        resetAllInput() {
            this.sortBy = ''
            this.priceMin = null
            this.priceMax = null
            this.selectedCategory = ''
            this.selectedCondition = ''
        }
    },
    computed: {
        ...mapGetters(['itemsOnDisplay', 'setConditions', 'setCategories', 'unfilteredItems']),
        resultsCountMsg() {
            if(this.itemsOnDisplay){
                let resultCount = this.itemsOnDisplay.length
                let resultMsg = ''
                if(resultCount > 1) { resultMsg = `${resultCount} Results`}
                else { resultMsg = `${resultCount} Result` }
                return resultMsg
            }
            return null
        },
        theSortOptions() {
            let sortArr = [
                {
                    text: 'newest',
                    value: 'newest'
                },
                {
                    text: 'relevance',
                    value: 'relevance'
                },
                {
                    text: 'most expensive',
                    value: 'expensive'
                },
                {
                    text: 'most affordable',
                    value: 'affordable'
                },
            ]
            return sortArr
        },
        theConditions(){
            if(this.setConditions){
                return this.setConditions
            }
            return []
        },
        theCategories(){
            if(this.setCategories){
                return this.setCategories
            }
            return [] 
        },
        clearFilterCheck(){
            if(this.unfilteredItems && this.unfilteredItems.length){
                return true
            }
            return false
        },
    },
    components: {
        appSearchFilterMobile: SearchFilterMobile
    }
}
</script>